"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBodyProps = void 0;
var setBodyProps = function (_a) {
    var overflow = _a.overflow, ariaHidden = _a.ariaHidden, tabIndex = _a.tabIndex;
    var root = document.getElementById('root');
    if (root) {
        if (tabIndex)
            root.tabIndex = tabIndex;
        else
            root.removeAttribute('tabindex');
        root.style.overflow = overflow;
        root.setAttribute('aria-hidden', ariaHidden.toString());
    }
};
exports.setBodyProps = setBodyProps;
